import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Appendix from  "./Documentation/Appendix.pdf"
import CritA from "./Documentation/Criterion_A_Planning.pdf"
import CritB from "./Documentation/Criterion_B_Design.pdf"
import CritC from "./Documentation/Criterion_C_Development.pdf"
import CritD from "./Documentation/Criterion_D_Functionality.mkv"
import CritE from "./Documentation/Criterion_E_Evaluation.pdf"
import CritBd from "./Documentation/Criterion_B_Record_of_Tasks.pdf"
import sourcecode from "./source-code/sourcecode.zip"
import favicon from "./Documentation/favicon-16x16.png"


function RenderList() {


  return (


<div className="list-container">

  <h5 className="documentation">Documentation Links</h5>
    <ul className="criterion-lists">
      <li>
      

      <a href={CritA} target="_blank"
                    rel="noreferrer">Planning</a>

      </li>
      <li>
      <a href={CritB} target="_blank"
                    rel="noreferrer">Design</a>
      </li>
      <li>
      <a href={CritC} target="_blank"
                    rel="noreferrer">Development/Code</a>
      </li>
      <li>
      <a href={CritD} target="_blank"
                    rel="noreferrer">Functionality Video (.mkv)</a>
      </li>
      <li>
      <a href={CritE} target="_blank"
                    rel="noreferrer">Evaluation</a>
      </li> 
      <li>
      <a href={Appendix} target="_blank"
                    rel="noreferrer">Appendix/ Customer Feedback</a>
      </li>
      <li>
      <a href={CritBd} target="_blank"
                    rel="noreferrer">ROT</a>   </li>
    </ul>
 </div> );
}



function RenderImage() {


  return(

    <div>
  <img className= "picture" src={require('./react.png')} alt="React Logo" width={"40px"} />
 

    
    
   <h4 className="image-text ">Made with React, by pacifictrout</h4>
     
     
     </div>
  );




}
   
function RenderHeader() {


return(
<div> <h1 className="h1">Employee Management System</h1>



  </div>


);
}
function DownloadSource() {

  const linkStyles = {
    color: 'inherit',      // Use the parent element's color (or set to your desired color)
    textDecoration: 'none', // Remove the underline
    cursor: 'pointer'}

return(
<div className="button-container">
      
      <a  style = {linkStyles}href= {sourcecode}>Download Source Code</a>
    </div>

);

}



function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <p>&copy; {currentYear} Pacifictrout. All rights reserved.</p>
        <p>This website presents the different stages of developmnet of an employee management system. <br></br>Contact me at s@pacifictrout.com for any questions</p>
      </div>
    </footer>
  );
}

function FinalRender() {
  return (
    <div className="center-container">
      <RenderImage/>
      <RenderHeader />
      <DownloadSource/>
      <RenderList />
      <Footer/>
      
    
    </div>
  );
}







const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>

    <FinalRender />
  </React.StrictMode>

);


const link = document.querySelector("link[rel~='icon']");
if (link !== null) {
  link.href = favicon;
} else {
  const newLink = document.createElement('link');
  newLink.rel = 'icon';
  newLink.href = favicon;
  document.head.appendChild(newLink);
}








